const underwearWomen = [
  { title: "Bras", icon: "icon1", subcategories: [] },
  { title: "Panties", icon: "icon2", subcategories: [] },
  { title: "Boyshorts", icon: "icon2", subcategories: [] },
  { title: "Lingerie", icon: "icon2", subcategories: [] },
];

export default underwearWomen;
